import './styles.scss'
import ConnectDeviceInformationCard from '@/authenticated/components/ConnectDeviceInformationCard'
import connectUtilityAnimation from '@/app/img/connect-utility-lottie.json'
import Lottie from 'lottie-react'

export interface Props {
  onClick: () => void
  onBackClick?: () => void
}

type InformationCard = {
  title: string
  subtitle: string
  stringIcon: string
}

const informationCards: InformationCard[] = [
  {
    title: 'Compare and act',
    subtitle:
      'See how your devices contribute to your overall bill, and get alerts when prices jump',
    stringIcon: '1',
  },
  {
    title: 'Keep up to date',
    subtitle:
      'Get your energy rates directly from your utility, so you stay in sync through seasons and policy changes',
    stringIcon: '2',
  },
  {
    title: 'Stay informed',
    subtitle:
      'See the exact cost of your home utility bill including fees, taxes, and delivery over every tier',
    stringIcon: '3',
  },
]

const ConnectUtilityAnimation = (
  <Lottie animationData={connectUtilityAnimation} loop />
)

export default function ConnectUtilityInformationCard(props: Props) {
  return (
    <ConnectDeviceInformationCard
      onboarding
      media={ConnectUtilityAnimation}
      id="connect-utility-information-card"
      headerlessOnDesktop={false}
      title={'Connect Utility'}
      subtitle={
        'Take your data up a notch - Optiwatt offers whole home insights that drive individual device performance'
      }
      informationCards={informationCards}
      onClick={props.onClick}
      onBackClick={props.onBackClick}
    />
  )
}
